module.exports = __webpack_public_path__ + "static/media/Vazir.03ed11c5.woff";